import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => {
    if (process.env.NODE_ENV !== "production") {
        if (props["aria-hidden"] !== "true" &&
            props["aria-label"] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "m264.6 70.63 176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.813-9.156-9.5-8.812-24.75.813-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6c-9.61-9.207-9.91-24.457-.81-33.987 9.2-9.6 23.5-9.94 34-.82z" }) }));
};
export default SvgArrowRight;
